<script setup>
import { ref } from 'vue';

defineProps({
    titulo: {
        type: String,
        required: true
    },
    descricao: {
        type: String,
        default: ''
    },
    labelBotaoFechar: {
        type: String,
        default: 'Fechar'
    },
    largura: {
        type: String,
        default: '65vw'
    },
    breakpoints: {
        type: Object,
        default: () => ({ '960px': '90vw', '640px': '90vw' })
    },
});

const emit = defineEmits(['fechar']);

const visible = ref(true);

const handleFechar = () => {
    visible.value = false;
};

const handleAfterHide = () => {
    emit('fechar');
};
</script>

<template>
    <Dialog :visible="visible" :closable="false" appendTo="body" modal :style="{ width: largura }"
        :breakpoints="breakpoints" :draggable="false" :resizable="false" @after-hide="handleAfterHide" :pt="{
            header: { class: 'pb-0' },
            footer: { class: 'px-4 lg:px-5 pt-4' },
            content: { class: 'px-5 pt-3 surface-card' },
        }">
        <form class="surface-card">
            <div class="grid formgrid p-fluid flex justify-content-between mb-3 gap-3 lg:gap-0">
                <div class="col-12 lg:col-4 relative">
                    <CabecalhoListas :titulo="titulo" :descricao="descricao" class="sticky top-0">
                        <template v-if="$slots.descricao" #descricao>
                            <slot name="descricao"></slot>
                        </template>
                    </CabecalhoListas>
                </div>

                <!-- Conteúdo do formulário customizado via slot -->
                <div class="grid formgrid p-fluid col-12 lg:col-7">
                    <slot></slot>
                </div>
            </div>
        </form>

        <template #footer>
            <div class="flex gap-3 justify-content-end">
                <Button :label="labelBotaoFechar" @click="handleFechar" class="p-button-text"
                    severity="secondary"></Button>

                <!-- Botão de confirmação opcional -->
                <slot name="botaoconfirmar"></slot>
            </div>
        </template>
    </Dialog>
</template>
